/**
 * Created by aaikepae on 2/10/17.
 */
import React from "react"
import SandboxInfoCard from "../sandboxInfoCard/SandboxInfoCard"
import {generate} from "Common/utility/infoCard"


export default class Sandbox extends React.Component {


  render() {
    const {config, location} = this.props;

    if (!config) {
      return <span>Loading</span>
    }


    const {title} = generate(config, location, this.props.type);
    const description = config.queryChild("description") ? config.queryChild("description").innerText.trim() : null;
    const detail_link = config.querySelector("descriptionDetailLink") ? generate(config.querySelector("descriptionDetailLink"), location, this.props.type).link : null;
    const sandbox = config.querySelector("sandboxInfo");
    const viewAll = detail_link ? (
      <span data-track-name="sandbox:viewall"
                  data-track-value="VIEWALL" >
              {detail_link}
            </span>
    ) : null;

    return (
      <div className="pubhub-sandbox pubhub-widget">
        <div className="container">
          <h1 className="pubhub-sandbox-title">{title}</h1>
          <div className="pubhub-sandbox-lead">
            {description}
            {viewAll}
          </div>
        </div>

        <SandboxInfoCard config={sandbox} location={location}></SandboxInfoCard>
      </div>
    );
  }
}
